import { FilePondFile, FileStatus } from "filepond";
import { ObjectUtils } from "util/ObjectUtils";

type Erros = {[key: string]: {[key: string]: string}};

export function validadorAnexos(name: string, anexos: FilePondFile[]) {
  const erros: Erros = { };

  if (anexos.length > 0) {
    const anexosAindaNaoEnviados = anexos
      .filter((it: FilePondFile) => it.status === FileStatus.PROCESSING || it.status === FileStatus.PROCESSING_QUEUED);

    if (anexosAindaNaoEnviados.length > 0) {
      ObjectUtils.popular(erros, 'Ainda existem arquivos em processo de envio. Após a finalização, tente salvar novamente', name);
    }
  }

  return erros;
}
